import { FC } from "react";

import { VnBadge } from "@/components/VnBadge/VnBadge";
import { VnBox } from "@/components/VnBox";
import { VnScrollView } from "@/components/VnScrollView";
import { VnText } from "@/components/VnText/VnText";
import { usePlatformOS } from "@/hooks/usePlatformOS";
import { useTranslator } from "@/hooks/useTranslate";

type EligibilityHouseholdMembersBannerPropsType = {
  members: {
    id: string;
    firstName: string;
    relationshipLabel: string;
  }[];
};

export const EligibilityHouseholdMembersBanner: FC<
  EligibilityHouseholdMembersBannerPropsType
> = ({ members }) => {
  const { isWeb } = usePlatformOS();
  const { t } = useTranslator();

  return (
    <VnBox className="bg-chart-four dark:bg-secondary shrink-0">
      <VnBox className="container mx-auto md:max-w-screen-md">
        <VnScrollView
          horizontal
          showsHorizontalScrollIndicator
          persistentScrollbar
          className="grow-0"
          contentContainerClassName="items-center gap-2 px-6 py-2"
          tabIndex={isWeb ? 0 : undefined}
          accessibilityLabel={t("native:eligibilityHouseholdMembers.title")}>
          <VnText
            variant="mdBold"
            className="text-muted-foreground shrink-0"
            numberOfLines={1}
            i18nKey="native:eligibilityHouseholdMembers.title"
          />
          {members.map(member => (
            <VnBadge
              key={member.id}
              variant="secondary"
              className="rounded-full px-3 py-1.5">
              <VnText className="text-sm" variant="mdMedium" numberOfLines={1}>
                {member.firstName}
              </VnText>
              {member.relationshipLabel && (
                <VnText
                  className="text-muted-foreground font-primary text-sm"
                  numberOfLines={1}>
                  {member.relationshipLabel}
                </VnText>
              )}
            </VnBadge>
          ))}
        </VnScrollView>
      </VnBox>
    </VnBox>
  );
};
